


















import Vue from 'vue'

interface ComponentData {
  focusNumber: boolean
}

export default Vue.extend({
  name: 'NumberField',

  props: {
    value: Number,
    tabindex: Number,
    label: String,
    dense: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    minDigital: {
      type: Number,
      default: undefined
    },
    maxDigital: {
      type: Number,
      default: 16
    },
  },

  data (): ComponentData {
    return {
      focusNumber: false
    }
  },

  watch: {

  },

  computed: {
    number: {
      get (): number {
        return this.value
      },

      set (val: string): void {
        if(isNaN(parseFloat(val))) {
          this.$emit('input', null)
        } else {
          this.$emit('input', parseFloat(val))
        }
      }
    }
  },

  methods: {
    formatNumber(value: number): any {
      if(isNaN(value) || value == null) {
        return ''
      } else {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: this.minDigital,
          maximumFractionDigits: this.maxDigital
        }).format(value)
      }
    },

    onFocus (): void {
      this.focusNumber = true
      const field: any = this.$refs['field']
      if (field) {
        setTimeout(()=> {
          field.$el.querySelector('input').select()
        },0)
      }
    },

    onChange (value: any): void {
      const valueLength: number = value !== null ? value.toString().split(".")[1] ? value.toString().split(".")[1].length : 0 : 0
      if(this.minDigital) {
        if(valueLength >= this.minDigital && valueLength <= this.maxDigital) {
          this.number = parseFloat(parseFloat(value).toFixed(valueLength))
        } else if(valueLength < this.minDigital) {
          this.number = parseFloat(parseFloat(value).toFixed(this.minDigital))
        } else {
          this.number = parseFloat(parseFloat(value).toFixed(this.maxDigital))
        }
      } else if(valueLength > this.maxDigital) {
        this.number = parseFloat(parseFloat(value).toFixed(this.maxDigital))
      } else {
        this.number = parseFloat(parseFloat(value).toFixed(valueLength))
      }
      this.$emit('change', this.number)
    },

    focus (): void {
      setTimeout(() => {
        const field: any = this.$refs['field']
        if (field) {
          field.focus()
        }
      }, 0)
    }
  },

  mounted () { }
})
